export const root = "r5o9yph";
export const imageWrapper = "i10t9xcw";
export const image = "i1i68lpj";
export const truncate = "t10bqib7";
export const text = "tbxyhz2";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");